/** Public business details used for legal pages & PhonePe / PG compliance */
export const BUSINESS = {
  legalName: "DevzCorner",
  brandName: "Devzcorner",
  email: "hello@devzcorner.com",
  phoneDisplay: "+91 89047 78939",
  phoneHref: "tel:+918904778939",
  addressLines: [
    "Silicon Town Main Road",
    "Doddanagamangala, Electronic City Phase-2",
    "Bengaluru (Urban), Karnataka 560100",
    "India",
  ],
  addressOneLine:
    "Silicon Town Main Road, Doddanagamangala, Electronic City Phase-2, Bengaluru (Urban), Karnataka 560100, India",
};
